export const getCategoryBySlug = (categories, slug) => {
	return Object.values(categories.byId).filter(
		(category) => category.slug === slug
	)[0];
};
